import { render, staticRenderFns } from "./ButtonTooltip.vue?vue&type=template&id=cfd366a2&"
import script from "./ButtonTooltip.vue?vue&type=script&lang=js&"
export * from "./ButtonTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports